<template>
    <CustomHeader :text="$t('gameLog.gameRegistration')" />
    <div class="container">
        <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="onClickTab">
            <van-tab v-for="(item, index) in dataSet.tabList" :key="index" :title="`${item.timeName} ${$t(item.name)}`" :name="index">
                <div class="content">
                    <div class="top_card">
                        <div class="card_text">{{ $t('gameLog.latestData') }} {{ item.timeName + ' ' + $t(item.name) }}</div>
                        <div class="card_text">{{ $t('common.bets') }} {{ dataSet.total }} {{ $t('common.times') }}:
                            <span>
                                {{ formatCurrency(dataSet.betTotal) }}
                            </span>
                        </div>
                        <div class="card_text">{{ $t('gameLog.winOrLoss') }}：
                            <span>
                                {{ formatCurrency(dataSet.winLossAmount) }}
                            </span>
                        </div>
                    </div>
                    <div v-if="dataSet.betList.length > 0">
                        <div v-for="(item, index) in dataSet.betList" :key="index">
                            <LogCard :bet-amount="item.betAmount" :returnAmount="item.winAmount" :profit="item.income"
                                :time="item.createTime" :sessionId="item.orderNo" :gameName="item.gameName" />
                        </div>
                        <van-row v-if="dataSet.total > dataSet.pageSize * dataSet.pageNum">
                            <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                                    @click="getNextPageMsgList"></van-col>
                        </van-row>
                        <div v-else class="no_more">{{ $t('message.noMore') }}</div>
                    </div>
                    <div v-else>
                        <NoData />
                        <div class="sub_text">
                            {{ $t('gameLog.subText') }}
                        </div>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script setup lang="ts">
import {defineProps, defineEmits, ref } from 'vue';
import LogCard from './components/logCard.vue';
import { formatCurrency } from '@/utils/commonFunction';
import CustomHeader from '../components/common/customHeader.vue';
import NoData from '../components/common/noData.vue';
import { GameLogData } from '@/view/gameLog/supportScript';

const props = defineProps<{
    dataSet: GameLogData
}>()

const active = ref(props.dataSet.active);

const emits = defineEmits(['onClickTab', 'getNextPageMsgList'])

const onClickTab = (active: any) => {
    emits('onClickTab', active)
}
const getNextPageMsgList = () => {
    emits('getNextPageMsgList')
}


</script>
<style scoped>
.container {
    padding: 70px 0;

}

.container>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.container>>>.van-tab {
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.45);
    border-radius: 30px;
    font-size: 12px;
    margin: 5px;
    height: 35px;
    padding: 0 15px;
}

.container>>>.van-tab.van-tab--active {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.content {
    color: #fff;
    padding: 15px;
}

.top_card {
    background: #3D2E22;
    border: 0.5px solid rgba(221, 122, 51, 0.25);
    border-radius: 10px;
    padding: 15px;
}

.card_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 11.75px;
    padding: 2.5px 0;
}

.card_text span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
}

.sub_text {
    color: rgba(255, 255, 255, 0.45);
    text-align: center;
    padding: 15px 70px;
    font-size: 12px;
}

.no_more {
    color: #969799;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}

:deep(.van-tabs__wrap),
:deep(.van-tabs__scroll),
:deep(.van-tabs__nav),
:deep(.van-tabs__nav--line),
:deep(.van-tab) {
    scrollbar-width: none !important;  /* Firefox */
}

:deep(.van-tabs__wrap::-webkit-scrollbar),
:deep(.van-tabs__scroll::-webkit-scrollbar),
:deep(.van-tabs__nav::-webkit-scrollbar),
:deep(.van-tabs__nav--line::-webkit-scrollbar),
:deep(.van-tab::-webkit-scrollbar) {
    display: none !important;   /* Chrome, Safari, Edge */
}
</style>